<tt-page>
    <tt-page-heading> {{ heading }}</tt-page-heading>
    <tt-select-line-products [params]="params" (getLoaded)="setHeading($event)" (submit)="onSubmit($event)"></tt-select-line-products>
</tt-page>
